<template>
    <div>
        <main-toolbar
            @back="$router.push({ name: 'home' })"
        />
        <div>
            <div class="home">
                <div class="logo-wrapper pt-4 pb-4">
                    <router-link :to="{ name: 'home' }">
                        <img src="/img/logo.png" alt="kapitani.bg logo" class="logo">
                    </router-link>

                    <div class="course-title text-center" v-if="course">
                        <div class="container">
                            {{ course.title }}
                        </div>
                    </div>
                </div>

                <div
                    class="btn-list-wrapper"
                    @click="startLearningPopup"
                >
                    <div class="container">
                        Обучение
                    </div>
                </div>

                <div
                    class="btn-list-wrapper"
                    @click="startExamPopup"
                >
                    <div class="container">
                        Изпит
                    </div>
                </div>
            </div>

            <!-- Modal -->
            <div class="modal" id="learning-modal" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body">
                            <button type="button" class="btn btn-block btn-lg btn-primary" @click="continueLearning()">Продължи</button>
                            <button type="button" class="btn btn-block btn-lg btn-primary" @click="newLearningPopup()">Ново обучение</button>
                            <button type="button" class="btn btn-block btn-lg btn-light" data-dismiss="modal">Отказ</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal -->
            <div class="modal" id="new-learning-modal" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Изберете теми</h5>
                        </div>
                        <div class="modal-body" v-if="course">
                            <div>
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="all-topics" class="custom-control-input" :value="true" v-model="allLearningTopics">
                                    <label class="custom-control-label" for="all-topics">Всички теми</label>
                                </div>
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="chosen-topics" class="custom-control-input" :value="false" v-model="allLearningTopics">
                                    <label class="custom-control-label" for="chosen-topics">Избрани теми</label>
                                </div>
                            </div>
                            <div v-if="!allLearningTopics">
                                <div
                                    class="subject-list"
                                    v-for="subject in course.subjects"
                                    v-bind:key="subject.id"
                                >
                                    <div class="subject-list-title">
                                        <div>
                                            {{ subject.title }}
                                        </div>

                                        <a href="#" @click.prevent="toggleAllTopics(subject.topics)">
                                            Избери всички
                                        </a>
                                    </div>

                                    <div class="topics-list">
                                        <span
                                            class="checkbox-pill"
                                            v-for="topic in subject.topics"
                                            v-bind:key="topic.id"
                                            @click="toggleLearningTopic(topic.id)"
                                            :class="{
                                                checked: learningTopics[topic.id]
                                            }"
                                        >
                                            {{ topic.title }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button :disabled="!this.allLearningTopics && !Object.keys(learningTopics).length" type="button" class="btn btn-block btn-lg btn-primary" @click="startNewLearning">Започване</button>
                            <button type="button" class="btn btn-block btn-lg btn-light" data-dismiss="modal">Отказ</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" id="exam-modal" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body">
                            <button type="button" class="btn btn-block btn-lg btn-primary" @click="continueExam">Продължи изпит</button>
                            <button type="button" class="btn btn-block btn-lg btn-primary" @click="startNewExam">Нов изпит</button>
                            <button type="button" class="btn btn-block btn-lg btn-light" data-dismiss="modal">Отказ</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Repository from '../../services/Repository';
    import ExamBuilder from '../../services/ExamBuilder';
    import jQuery from 'jquery';
    import courses from '../../data/courses';

    export default {
        data() {
            return {
                course: null,
                allLearningTopics: true,
                learningTopics: {}
            }
        },
        methods: {
            startLearningPopup() {
                let previousLearningTopics = Repository.loadLearningTopics(this.course.id);

                if (this.course.isSingleTopic()) {
                    Repository.saveLearningTopics(this.course.id, []);
                    this.continueLearning();

                    return;
                }

                if (!previousLearningTopics) {
                    this.$set(this, 'learningTopics', {});
                    jQuery('#new-learning-modal').modal('show');
                }
                else {
                    jQuery('#learning-modal').modal('show');
                }
            },

            newLearningPopup() {
                this.$set(this, 'learningTopics', {});
                jQuery('#new-learning-modal').modal('show');
            },

            startNewLearning() {
                if (this.allLearningTopics) {
                    Repository.saveLearningTopics(this.course.id, []);
                }
                else {
                    let topicIds = Object.keys(this.learningTopics);
                    Repository.saveLearningTopics(this.course.id, topicIds);
                }

                jQuery('#new-learning-modal').modal('hide');
                jQuery('#learning-modal').modal('hide');

                this.$router.push({
                    name: 'learning',
                    params: {
                        course: this.course.id,
                        question: 1
                    }
                })
            },

            continueLearning() {
                let question = Repository.getLatestLearningQuestion(this.course.id);
                jQuery('#learning-modal').modal('hide');

                this.$router.push({
                    name: 'learning',
                    params: {
                        course: this.course.id,
                        question: question
                    }
                })
            },

            startExamPopup() {
                const exam = Repository.loadExam(this.course.id);
                const isFinished = exam ? ExamBuilder.load(this.course).isFinished() : true;

                if (exam && !isFinished) {
                    jQuery('#exam-modal').modal('show');
                }
                else {
                    this.startNewExam();
                }
            },

            continueExam() {
                const exam = ExamBuilder.load(this.course);
                this.startExam(exam.currentQuestion);
            },

            startNewExam() {
                const exam = ExamBuilder.createNew(this.course);
                exam.save();

                this.startExam();
            },

            startExam(question = 1) {
                jQuery('#exam-modal').modal('hide');
                this.$router.push({
                    name: 'exam.question',
                    params: {
                        question,
                    }
                })
            },

            setCurrentCourse(id) {
                this.course = courses.find(course => parseInt(course.id, 10) === parseInt(id, 10))
            },

            toggleAllTopics(topics) {
                let anyUnchecked = false;

                for (let topic of topics) {
                    if (!this.learningTopics[topic.id]) {
                        anyUnchecked = true;
                        break;
                    }
                }

                if (anyUnchecked) {
                    for (let topic of topics) {
                        this.$set(this.learningTopics, topic.id, true);
                    }
                }
                else {
                    for (let topic of topics) {
                        this.$delete(this.learningTopics, topic.id);
                    }
                }
            },

            toggleLearningTopic(topicId) {
                if (this.learningTopics[topicId]) {
                    this.$delete(this.learningTopics, topicId);
                }
                else {
                    this.$set(this.learningTopics, topicId, true);
                }
            }
        },

        beforeRouteEnter (to, from, next) {
            next(vm => vm.setCurrentCourse(to.params.course));
        },

        // when route changes and this component is already rendered,
        // the logic will be slightly different.
        beforeRouteUpdate (to, from, next) {
            this.setCurrentCourse(to.params.course);
            next()
        }
    }
</script>